import { SizeProps } from './../../../@types/common.type';

export enum CheckboxColorProps {
  Default = 'default',
  Secondary = 'secondary',
  Primary = 'primary',
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warning = 'warning',
}

export interface CheckboxProps {
  checked?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- legacy callers pass mixed handlers; tightening to ChangeEvent cascades into BulkServiceEditor which is out of scope here
  onChange?: (event: any) => void;
  color?: CheckboxColorProps;
  indeterminate?: boolean;
  size?: SizeProps;
  disabled?: boolean;
  testDataId?: string;
  ariaLabel?: string;
}
